module.exports = __webpack_public_path__ + "img/income.1df9f005.jpg";